import { render } from "./LiveGridFilter.vue?vue&type=template&id=24a36486&scoped=true"
import script from "./LiveGridFilter.vue?vue&type=script&lang=js"
export * from "./LiveGridFilter.vue?vue&type=script&lang=js"

import "./LiveGridFilter.vue?vue&type=style&index=0&id=24a36486&scoped=true&lang=css"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a36486"]])

export default __exports__